import CONSTANTS from '@/constants'
import StackAPI from '@/lib/StackAPI'
import { captureException } from '@sentry/react'

type affiliateMailingPayload = {
  email: string
  first_name: string
  last_name: string
}

const ENDPOINT = 'api/webhooks/mailing_list_subscription'
const MAILING_LIST_ID = 3
const SOURCE = 'affiliate_contact_page'

export const subscribeAffiliate = async (data: affiliateMailingPayload) => {
  const { post } = StackAPI()

  const headers = {
    Authorization: CONSTANTS.MAILING_LIST_SUBSCRIPTION_WEBHOOK_AUTH_TOKEN,
    'X-Skip-Auth-Override': 'true'
  }

  const params = {
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    mailing_list_id: MAILING_LIST_ID,
    source: SOURCE
  }

  const request = {
    path: ENDPOINT,
    headers,
    params
  }

  try {
    await post(request)
  } catch (error) {
    captureException(error, { extra: { subscriptionData: params } })
  }
}
